// extracted by mini-css-extract-plugin
export default {"Button":"button_Button__XGvwL"};